export const formatGbp = (value: number) =>
  `£${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export const shareOfNegotiated = (count: number, negotiated: number) =>
  negotiated > 0 ? `(${((count * 100) / negotiated).toFixed(1)}%)` : null
